import List from "@/components/list";
import { tableBaseProps } from "@/utils/common.js";
import AddHtml from '@/pages/trainCodeRule/addHtml.vue';

const Table = (args) => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};
  const handleDetete = listeners["handleDetete"] || function() {};
  const handleEdit = listeners["handleEdit"] || function() {};

  const Deal = ({ props: { vo } }) => {
    const item = vo.row;
    const dealConf = [
      [
        "icon-edit",
        "编辑",
        () => {
          handleEdit(item);
        },
        "liveRoomRule:save",
      ],[
        "icon-delete",
        "删除",
        () => {
          handleDetete(item);
        },
        "liveRoomRule:delete",
      ],
    ];

    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    // {
    //   type: "selection",
    //   label: "main",
    // },
    tableBaseProps("学院名称", "deptName", "m150", true),
    tableBaseProps("干部级别", "cadreLevelsName", "m150", true),
    tableBaseProps("管理主体", "userLeaderTypesName", "m150", true),
    tableBaseProps("用户状态", "userStatusName", "m100", true),
    tableBaseProps("考核状态", "examStatusName", "m100"),
    tableBaseProps("浙政钉绑定状态", "bindStatusName", "m100"),
    {
      label: "操作",
      fixed: "right",
      minWidth: 100,
      render: (vo) => <Deal vo={vo} />,
    }
  ];

  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
